import styled from '@emotion/styled';

export {
  /**
   * @deprecated  `@emotion/styled` is planned to be removed in the future. Do not use for new components.
   **/
  styled,
};
